import {PriceFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {
  Divider,
  FilterFlyoutBoolean,
  FilterFlyoutPrice,
} from '@aboutyou/ui-components';
import React from 'react';
import {usePriceFilterSection} from '../../shared/usePriceFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: PriceFilterSection;
  resetFilter: (slug: string) => void;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    singleSelectOnly?: boolean;
  }) => void;
  hide: VoidFunction;
  isOpen: boolean;
  open: (sections: string[]) => void;
  submit: VoidFunction;
};

export const FilterSectionPrice: React.FC<Props> = ({
  activeFilters,
  data,
  resetFilter,
  setFilter,
  isOpen,
  open,
  hide,
  submit,
}) => {
  const {
    priceSlider,
    totalMax,
    totalMin,
    currencyCode,
    slug,
    setValues,
    values,
    saleFilterLabel,
    saleFilterSlug,
    saleFilterActive,
    hasAppliedPriceRange,
    handleApplyPriceRange,
  } = usePriceFilterSection({data, activeFilters, setFilter});

  const handleOpen = () => {
    open([priceSlider.slug]);
  };

  if (!priceSlider || !slug || !totalMax) return null;

  return (
    <FilterFlyoutPrice
      label={priceSlider.label}
      max={totalMax}
      min={totalMin}
      currencyCode={currencyCode}
      onApply={handleApplyPriceRange}
      onChange={setValues}
      values={values}
      hide={hide}
      isOpen={isOpen}
      open={handleOpen}
      submit={submit}
      hasActivePrice={hasAppliedPriceRange}
      priceRanges={data.priceRanges?.segments || []}
    >
      {saleFilterLabel && saleFilterSlug && (
        <>
          <Divider />
          <FilterFlyoutBoolean
            active={saleFilterActive}
            data-testid="filterFlyoutSaleToggle"
            label={saleFilterLabel}
            onToggle={() =>
              saleFilterActive
                ? resetFilter(saleFilterSlug)
                : setFilter({
                    filterId: 'true',
                    filterSection: saleFilterSlug,
                  })
            }
          />
        </>
      )}
    </FilterFlyoutPrice>
  );
};
